import { createStyles, makeStyles, TextField } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) =>
    createStyles({
        input: {
            minWidth: 300,
            [theme.breakpoints.down('sm')]: {
                minWidth: 'unset',
            }
        }
    }),
);

interface Props {
    placeholder?: string
    type?: React.InputHTMLAttributes<unknown>['type']
    fullWidth?: boolean
    value?: string
    onChange?: (value: string) => void
}

export default function LightInput({
    placeholder,
    type,
    fullWidth,
    value,
    onChange
}: Props) {
    const classes = useStyles();
    // const [value, onChange] = React.useState("");

    return (
        <TextField
            className={classes.input}
            classes={{ root: "lightInput" }}
            InputProps={{ style: { backgroundColor: '#fff' } }}
            type={type}
            fullWidth={fullWidth}
            variant="outlined"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.currentTarget.value)}
        />
    )
}
